import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { RouterModule } from '@angular/router';
import { BinaProposalComponent, BinaSidebarComponent } from '@shared/bina-mutual/components';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  declarations: [BinaSidebarComponent, BinaProposalComponent],
  imports: [CommonModule, MutualModule, TranslateModule, PipesSharedModule, RouterModule, NzToolTipModule],
  exports: [BinaSidebarComponent, BinaProposalComponent],
})
export class BinaSidebarMutualModule {}
